module.exports = __webpack_public_path__ + "static/img/double_fun_pizza.9113481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/double_fun_pizza.png
// module id = fsj3
// module chunks = 0